"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es7.object.values");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports["default"] = AddressDropdown;

var _react = _interopRequireWildcard(require("react"));

var _provinceList = _interopRequireDefault(require("../../static/province-list.json"));

var _horizontalSpacer = _interopRequireDefault(require("../spacers/horizontalSpacer"));

var _input = _interopRequireDefault(require("../inputs/input"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function AddressDropdown(props) {
  var setCityAddress = props.setCityAddress,
      _props$errors = props.errors,
      errors = _props$errors === void 0 ? {} : _props$errors,
      _props$inputProps = props.inputProps,
      inputProps = _props$inputProps === void 0 ? _extends({
    labelTextProps: {
      color: "#000"
    },
    fontSize: "1.2",
    flex: 1
  }, props.inputProps) : _props$inputProps,
      parsedCityAddress = props.parsedCityAddress,
      allowPredictive = props.allowPredictive;

  var _useState = (0, _react.useState)(""),
      province = _useState[0],
      setProvince = _useState[1];

  var _useState2 = (0, _react.useState)(""),
      municipality = _useState2[0],
      setMunicipality = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      barangay = _useState3[0],
      setBarangay = _useState3[1];

  (0, _react.useEffect)(function () {
    if (parsedCityAddress) {
      setProvince(parsedCityAddress.province);
      setMunicipality(parsedCityAddress.municipality);
      setBarangay(parsedCityAddress.baranggay);
    }
  }, [parsedCityAddress]);

  var checkPredictiveInput = function checkPredictiveInput(options, selected) {
    var error = null;
    var valid = options.map(function (item) {
      return item.value;
    });

    if (selected && !selected.value) {
      error = "Please select a valid value";
    }

    return error;
  };

  var provinces = Object.values(_provinceList["default"].REGION_MAP).reduce(function (current, value) {
    return current.concat(value.map(function (province) {
      return {
        id: province,
        value: province
      };
    }));
  }, []).sort(function (a, b) {
    return a.value.localeCompare(b.value);
  });
  var municipalities = province && allowPredictive && !checkPredictiveInput(provinces, province) ? Object.keys(_provinceList["default"].PROVINCE_MAP[province && province.value || ""].municipalities).map(function (m) {
    return {
      id: m,
      value: m
    };
  }) : [];
  var barangays = municipality && allowPredictive && !checkPredictiveInput(municipalities, municipality) ? _provinceList["default"].PROVINCE_MAP[province && province.value || ""].municipalities[municipality && municipality.value || ""].baranggays.map(function (b) {
    return {
      id: b.name,
      value: b.name
    };
  }) : [];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      zIndex: "3",
      position: "relative"
    }
  }, /*#__PURE__*/_react["default"].createElement(_input["default"], _extends({}, inputProps, {
    label: "Province",
    placeholder: "Select Province",
    options: provinces,
    error: errors.province || allowPredictive && checkPredictiveInput(provinces, province),
    allowPredictive: allowPredictive,
    value: province ? province.value : "",
    onClickOption: function onClickOption(option) {
      setProvince(option);
      setMunicipality(null);
      setBarangay(null);
      setCityAddress(option, "", "");
    },
    onClear: function onClear() {
      setCityAddress("", "", "");
      setProvince(null);
      setMunicipality(null);
      setBarangay(null);
    }
  }))), province && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      zIndex: "2",
      position: "relative"
    }
  }, /*#__PURE__*/_react["default"].createElement(_horizontalSpacer["default"], {
    height: ".6rem"
  }), /*#__PURE__*/_react["default"].createElement(_input["default"], _extends({
    style: {
      position: "relative"
    }
  }, inputProps, {
    label: "Municipality",
    placeholder: "Select Municipality",
    options: municipalities,
    allowPredictive: allowPredictive,
    error: errors.municipality || allowPredictive && checkPredictiveInput(municipalities, municipality),
    value: municipality ? municipality.value : "",
    onClickOption: function onClickOption(option) {
      setMunicipality(option);
      setBarangay(null);
      setCityAddress(province, option, "");
    },
    onClear: function onClear() {
      setCityAddress(province, "", "");
      setMunicipality(null);
      setBarangay(null);
    }
  }))), municipality && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      zIndex: "1",
      position: "relative"
    }
  }, /*#__PURE__*/_react["default"].createElement(_horizontalSpacer["default"], {
    height: ".6rem"
  }), /*#__PURE__*/_react["default"].createElement(_input["default"], _extends({}, inputProps, {
    label: "Barangay",
    placeholder: "Select Barangay",
    options: barangays,
    allowPredictive: allowPredictive,
    error: errors.barangay || allowPredictive && checkPredictiveInput(barangays, barangay),
    value: barangay ? barangay.value : "",
    onClickOption: function onClickOption(option) {
      setBarangay(option);
      setCityAddress(province, municipality, option);
    },
    onClear: function onClear() {
      setCityAddress(province, municipality, "");
      setBarangay(null);
    }
  }))));
}

module.exports = exports["default"];